import { Backdrop, Button, Grid, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAddDivisi } from "../../../../api/effects/mutations/Divisi/addDivisi";
import { useEditDivisi } from "../../../../api/effects/mutations/Divisi/EditDivisi";
import { useFetchDivisi } from "../../../../api/effects/mutations/Divisi/useFetchDivisi";
import { useAddPendidikan } from "../../../../api/effects/mutations/Pendidikan/addPendidikan";
import { useEditPendidikan } from "../../../../api/effects/mutations/Pendidikan/EditPendidikan";
import { useFetchPendidikan } from "../../../../api/effects/mutations/Pendidikan/useFetchPendidikan";
import { useAddSusunanKeluarga } from "../../../../api/effects/mutations/SusunanKeluarga/addSusunanKeluarga";
import { useEditSusunanKeluarga } from "../../../../api/effects/mutations/SusunanKeluarga/editSusunanKeluarga";
import { useFetchSusunanKeluarga } from "../../../../api/effects/mutations/SusunanKeluarga/useFetchSusunanKeluarga";
import InputDate from "../../../../components/InputDate";
import InputRadio from "../../../../components/InputRadio";
import InputSelect from "../../../../components/InputSelect";
import InputTextField from "../../../../components/InputTextField";
import { convertDate } from "../../../../utils/dateConvert";
import RadioButton from "../../RadioButton";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  width: "45%",
  [theme.breakpoints.down("md")]: {
    width: "60%",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
  },
  margin: "1%",
}));

const FullButton = styled(Button)(({ theme }) => ({
  marginTop: "3vh",
  marginBottom: "1vh",
  width: "60%",
}));

const ScrollGrid = styled(Grid)(({ theme }) => ({
  overflow: "auto",
  maxHeight: "90vh",
}));

type Props = {
  open: boolean;
  handleClose: () => void;
  ID?: number;
};

export default function PendidikanModal({ ID = -1, open, handleClose }: Props) {
  const [pendidikan, setPendidikan] = useState("");
  const [isActive, setIsActive] = useState(false);

  const { mutateAsync: GetPendidikanData } = useFetchPendidikan({
    onSuccess(data) {
      setPendidikan(data.PENDIDIKAN);
      setIsActive(data.IS_ACTIVE);
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  useEffect(() => {
    if (ID > 0) {
      GetPendidikanData(ID);
    } else {
      setPendidikan("");
      setIsActive(false);
    }
  }, [open]);

  const handlePendidikan = (e: any) => {
    setPendidikan(e.target.value);
  };

  const handleIsActive = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsActive(e.target.value === "true");
  };

  const handleSave = () => {
    if (ID > 0) {
      EditPendidikan({
        PENDIDIKAN_ID: ID,
        PENDIDIKAN: pendidikan,
        IS_ACTIVE: isActive,
      });
    } else {
      AddPendidikan({
        PENDIDIKAN: pendidikan,
        IS_ACTIVE: isActive,
      });
    }
  };

  const { mutateAsync: AddPendidikan } = useAddPendidikan({
    onSuccess() {
      handleClose();
      setPendidikan("");
      setIsActive(false);
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  const { mutateAsync: EditPendidikan } = useEditPendidikan({
    onSuccess() {
      handleClose();
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <SquareGrid container>
        <ScrollGrid container>
          <Grid container justifyContent="flex-start" paddingLeft={"10.5%"} item xs={6}
            paddingBottom={
              {
                xs: 5,
                sm: 5,
                md: 5,
                lg: 5,
                xl: 5
              }}>
            <Typography variant="subtitle1" color="black">
              {ID === -1 ? "Tambah Pendidikan" : "Ubah Pendidikan"}
            </Typography>
          </Grid>
          <Grid container justifyContent="flex-end" item xs={6}>
            <Button onClick={handleClose}>Close</Button>
          </Grid>
          <InputTextField
            title={"Pendidikan"}
            value={pendidikan}
            handleEdit={handlePendidikan}
          />
           <RadioButton
            title="Active"
            value={isActive ? "true" : "false"}
            onChange={handleIsActive}
          />
          <Grid container justifyContent="center" item xs={12}>
            <FullButton variant="contained" onClick={handleSave}>
              Save
            </FullButton>
          </Grid>
        </ScrollGrid>
      </SquareGrid>
    </Backdrop>
  );
}
